import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import CartPage from "../pages/cart/page";
import ShopPage from "../pages/shop/page";
// Configurator is temporarily hidden from the site (not deleted).
// To re-enable: uncomment this import and the /configurator route below.
// import ConfiguratorPage from "../pages/configurator/page";
import B2BPage from "../pages/b2b/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  // Configurator route hidden for now (kept for future re-enable):
  // {
  //   path: "/configurator",
  //   element: <ConfiguratorPage />,
  // },
  {
    path: "/za-firme",
    element: <B2BPage />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
